import { PaymentApi } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class PaymentService {
    public static GetPaymentsAsFile = async (year: number) => {
        return new PaymentApi(GetApiConfiguration()).apiPaymentDownloadPaymentsGetRaw({ year });
    };

};
